import { t } from "i18next"
import { updatePrenotationViewAll } from "../../redux/reducer/prenotationViewReducer";
import { useAppDispatch } from "../../redux";

const AlertNotDateWhenChange = (props: any) => {
  let alertTimeslotInfo = props.alertTimeslotInfo;
  let selectedDay = props.selectedDay ?? "";
  let label = "error-not-date-attendance.edit-label2";
  let buttonLabel = alertTimeslotInfo?.day ?? "";
  if (alertTimeslotInfo?.day === selectedDay) {
    label = "error-not-date-attendance.edit-label3";
    buttonLabel = alertTimeslotInfo?.startDateNow
  }
  if (alertTimeslotInfo?.delete) {
    label = "error-not-date-attendance.remove-label";
  }

  const dispatch = useAppDispatch()

  const onDayClick = () => {
    dispatch(updatePrenotationViewAll([alertTimeslotInfo.ISODay, alertTimeslotInfo.timeSlot, alertTimeslotInfo?.bookingId]))

    if (typeof props.onDayClick === 'function') {
      props.onDayClick()
    }
  };

  return (
    <>
      <div className="DangerError OrangeBackground text-center mt-3">
        <>
          {t('error-not-date-attendance.edit-label')} <b>{alertTimeslotInfo?.guestObject.name} #{alertTimeslotInfo?.bookingId}</b> {t(label)}
          {((!alertTimeslotInfo?.delete) ?
            <button className="ButtonLink" onClick={onDayClick} >{buttonLabel}</button>
            :
            <></>)
          }
        </>
      </div>
    </>
  )
}

export default AlertNotDateWhenChange